export default 
{
	"progressbar-page-title": "Página",
	"name-suffix": "Sufijo",
	"fileupload-desc-progress-message": "Subiendo {progress}",
	"required-if-greater-than-or-equal": "{property} se necesario cuando {compareSource} es mayor que o igual a {compareValue}.",
	"powered-by-cognito": "Desarrollado por Cognito Forms.",
	"form-name-default": "Intitulado",
	"field-choice-defaults": "Primera Opción|Segunda Opción|Tercera Opción",
	"additional-fee-default-label": "Cargo adicional",
	"authenticated-save-and-resume-email-dialog": "Envíe por correo electrónico un enlace y vuelva a su formulario para completar el envío.",
	"string-length-between": "{property} debe estar entre {min} y {max} caracteres.",
	"update-button-text": "Actualizar",
	"address-zip-code-invalid": "Zip Code debe ser formateado como #####-####.",
	"required-if-greater-than": "{property} es necesario cuando {compareSource} es mayor que {compareValue}.",
	"compare-before": "{property} debe ser anterior {compareSource}.",
	"compare-after": "{property} debe ser posterior {compareSource}.",
	"unsupported-browser-message": "¡ Oh No! Usted está utilizando un navegador no compatible. {a}Haga clic aquí {/a} para actualizar.",
	"shared-entry-email-subject": "Enlace Compartido",
	"send-button-text": "Enviar",
	"venmo-help-text": "Conéctese a Venmo para continuar con el pago.",
	"field-repeatingsection-item-label": "Artículo",
	"save-and-resume-email-not-sent-message": "Había un problema.",
	"credit-card-cvv": "CVV",
	"range-at-least": "{property} debe ser al menos {min}.",
	"entry-notification-full-entry-detail-link": "Vea todos los detalles de la entrada en CognitoForms.com.",
	"element-label-website": "Sitio web",
	"element-label-signature": "Firma",
	"paypal-help-text": "Conéctese a PayPal para continuar con el pago.",
	"card-on-file-agreement-validation": "Debe aceptar guardar su tarjeta para futuras transacciones.",
	"marketing-button-4": "Construir Su Propia Forma Gratuita",
	"field-datepicker-now": "Ahora",
	"save-and-resume-email-resume-button": "Continuar ahora",
	"field-datepicker-next-month": "Próximo Mes",
	"quantity-remaining-text": "restante",
	"payment-declined": "Pago rechazado",
	"required-if-before": "{property} es necesario cuando {compareSource} es antes {compareValue}.",
	"this-comma-that": "{0}, {1}",
	"compare-less-than": "{property} debe ser menor que {compareSource}.",
	"entry-admin-link": "Enlace del administrador",
	"required-many": "{0} son necesarios.",
	"save-and-resume-multiple-days-expiration-email-message": "Use el enlace abajo para finalizar el formulario dentro de los {days} días siguientes.",
	"string-length-at-least": "{property} debe ser al menos {min} caracteres.",
	"credit-card-number": "Número de tarjeta de crédito",
	"range-on-or-before": "{property} debe ser igual o anterior {max}.",
	"required-one": "{0} es necesario.",
	"fileupload-max-file-count-exceeded-message": "Se pueden subir solo archivos de {maxFileCount}.",
	"order-transaction-details-header": "Detalles de la transacción",
	"field-spinner-increase": "Incrementar",
	"payment-processing-fees": "Tarifas de procesamiento",
	"payment": "Pago",
	"field-choice-other-fill-in": "Otros",
	"shared-entry-email-message": "Una entrada se ha compartido con usted.",
	"shared-entry-workflow-link": "Ver el formulario.",
	"required-if-exists": "{property} es necesario cuando {compareSource} se especifica.",
	"concurrent-conflict-toast-message": "Su envío falló porque la información en este formulario ha cambiado. Por favor revisa e intenta de nuevo.",
	"secured-by-paypal": "Protegido por",
	"range-on-or-after": "{property} debe ser igual o después {min}.",
	"payment-amount-due": "Total a pagar",
	"required-name-first-and-last": "Nombre y Apellidos son necesarios.",
	"required": "{property} es necesario.",
	"string-format-alphabetic": "{property} sólo debe contener letras.",
	"quantity-limit": "{property} cantidad excedida.",
	"field-spinner-decrease": "Disminuir",
	"field-repeatingsection-add-link-text": "Añadir",
	"fileupload-max-size-exceeded-message": "Sólo los archivos más pequeños que {maxSize} MB se pueden subir.",
	"credit-card-expiration": "MM/YY",
	"field-signature-notcaptured": "No Capturado",
	"field-ratingscale-satisfied-unsatisfied-label": "Satisfecho/Insatisfecho",
	"range-between": "{property} debe estar entre {min} y {max}.",
	"field-ratingscale-agree-disagree-label": "De acuerdo/En desacuerdo",
	"back-button-text": "Anterior",
	"address-country": "País",
	"order-not-found": "No se encontró la información de la orden.",
	"field-ratingscale-satisfied-unsatisfied-options": "Muy insatisfecho|Insatisfecho|Neutro|Satisfecho|Muy satisfecho",
	"entry-notification-entry-details-header": "Detalles de la entrada",
	"FALSE": "FALSO",
	"compare-greater-than-or-equal": "{property} debe ser mayor que o igual a {compareSource}.",
	"receipt-notification-order-details-desc-header": "Descripción",
	"order-method-label": "Método",
	"order-total-label": "Total de la orden",
	"invalid-shared-link": "Inválido Enlace Compartido",
	"fileupload-zero-byte-file-message": "No se puede subir archivo de cero bytes.",
	"range-at-most": "{property} debe ser como máximo {max}.",
	"format-integer": "####",
	"order-date-label": "Fecha",
	"fileupload-dropzone-message": "o arrastrar archivos aquí.",
	"shared-entry-view-link": "Ver la entrada compartida.",
	"format-currency": "#.###,## €",
	"string-length-at-most": "{property} debe ser al maximo de {max} caracteres.",
	"entry-confirmation-footer-tagline": "Cree su propia forma de pago con",
	"submit-button-text": "Enviar",
	"marketing-msg": "Cree fácilmente formas potentes.",
	"required-if-on-or-after": "{property} es necesario cuando {compareSource} es en o después  {compareValue}.",
	"card-on-file-agreement": "Acepto guardar mi tarjeta para futuras transacciones.",
	"signature-draw": "dibujar",
	"address-zip-code": "Zip Code",
	"compare-on-or-after": "{property} debe ser igual o después {compareSource}.",
	"required-if-less-than-or-equal": "{property} se necesario cuando {compareSource} es menor que o igual a {compareValue}.",
	"field-datepicker-next-year": "Próximo Año",
	"change-button": "cambiar",
	"fileupload-desc-size-in-bytes-message": "{size} bytes",
	"card-tab": "Tarjeta",
	"order-billing-info-header": "Información de facturación",
	"entry-email-view-details-text": "Vea todos los detalles de la entrada en CognitoForms.com.",
	"save-and-resume-one-day-expiration-email-message": "Use el enlace abajo para finalizar el formulario dentro del día siguiente.",
	"credit-card-authentication-failed": "La tarjeta falló la autenticación.",
	"compare-less-than-or-equal": "{property} debe ser menor o igual a {compareSource}.",
	"receipt-notification-order-details-balance-due": "Saldo debido",
	"save-and-resume-multiple-days-expiration-message": "Copie el enlace abajo o ingrese su correo electrónico para finalizar el formulario dentro de los {days} días siguientes.",
	"processing-fee-calculating-message": "Calculando",
	"receipt-notification-trx-details-method": "Método",
	"field-choice-no-match": "No hay datos que coincidan",
	"fileupload-invalid-file-type-message": "Se pueden subir solo archivos de {allowedTypes}.",
	"receipt-notification-trx-details-date": "Fecha",
	"credit-card-authorization": "Autorización de tarjeta",
	"address-line1": "Dirección línea 1",
	"required-if-not-exists": "{property} es necesario cuando {compareSource} no se especifica.",
	"required-if-not-equal": "{property} es necesario cuando {compareSource} no es {compareValue}.",
	"marketing-button-2": "Construir Su Propia Forma Gratuita",
	"receipt-notification-billing-info-header": "Información de facturación",
	"required-if-after": "{property} es necesario cuando {compareSource} es después de {compareValue}.",
	"element-label-name": "Nombre",
	"required-if-equal": "{property} es necesario cuando {compareSource} es {compareValue}.",
	"connected-to-paypal": "Conectado a PayPal.",
	"people-form-email-quantity-exceeded-message": "La dirección de correo electrónico debe ser única.",
	"receipt-notification-order-details-subtotal": "Total parcial",
	"shared-entry-edit-link": "Editar la entrada compartida.",
	"receipt-notification-trx-details-header": "Detalles de la transacción",
	"address-city": "Ciudad",
	"receipt-notification-order-details-amount-paid": "Cantidad pagada",
	"credit-card-invalid": "La tarjeta no es válida.",
	"format-decimal": "####,##",
	"entry-notification-new-submission-text": "Usted tiene un nuevo envío del formulario.",
	"this-and-that": "{0} y {1}",
	"field-ratingscale-good-poor-label": "Bueno/Malo",
	"network-unavailable-message": "Red no disponible, inténtelo de nuevo más tarde.",
	"dialog-close": "Cerrar",
	"string-format-alphanumeric": "{property} sólo debe contener letras y números.",
	"credit-card": "Tarjeta de crédito",
	"remove-item": "Eliminar {item}",
	"receipt-notification-order-details-price-header": "Precio",
	"fileupload-upload-inprogress-message": "Archivos subiendo en progresso.",
	"public-terms-of-service-link-text": "Condiciones del servicio",
	"save-and-resume-email-subject": "Guardar y Reanudar Enlace",
	"field-repeatingsection-remove-link-text": "Eliminar",
	"field-ratingscale-na-label": "N / A",
	"add-item": "Añadir {item}",
	"field-toggle-options": "Sí/No|Cierto/Falso|Abierto/Cerrado|Activo/Inactivo|Leído/No Leído",
	"order-submit-timeout": "Procesamiento de pedidos está durando demasiado. Intente por favor su pedido más adelante.",
	"listlength-at-most": "Por favor, especifique no más de {max} {property}.",
	"shared-entry-email-view-message": "Utilice el siguiente enlace para ver la entrada compartida.",
	"order-number-label": "Número",
	"card-declined": "Tarjeta rechazada",
	"fileupload-default-upload-button-text": "Subir",
	"name-prefix": "Titulo",
	"address-line2": "Dirección línea 2",
	"element-label-email": "Correo electrónico",
	"field-ratingscale-good-poor-options": "Muy malo|Malo|Medio|Bueno|Muy bueno",
	"next-button-text": "Siguiente",
	"question": "Pregunta",
	"address-postalcode": "Código Postal / Zip Code",
	"format-with-description": "{property} debe estar formateada como {description}.",
	"field-datepicker-prev-month": "Mes anterior",
	"name": "Nombre",
	"receipt-notification-order-details-total-footer": "Total",
	"confirmation-message": "Gracias por llenar el formulario. Su respuesta ha sido registrada.",
	"shared-entry-email-edit-message": "Utilice el siguiente enlace para editar la entrada compartida.",
	"field-default-label": "Intitulado",
	"required-value": "{property} debe ser {value}.",
	"name-middle": "Segundo Nombre",
	"fileupload-failed-upload-message": "{fileName} no se puede subir.",
	"shared-entry-email-button-label": "Ver la entrada",
	"field-datepicker-year": "",
	"element-label-phone": "Teléfono",
	"TRUE": "VERDADERO",
	"listlength-between": "Por favor, especifique entre los {min} y {max} {property}.",
	"marketing-button-1": "Inténtalo Ahora",
	"entry-submission-error-heading": "Error al procesar la entrada",
	"order-not-found-message": "No se encontró la información de la orden.",
	"format-without-description": "{property} propiedad no está formateado correctamente.",
	"name-last": "Apellidos",
	"field-ratingscale-one-five-label": "Escala de 1 a 5",
	"listlength-at-least": "Especifique por lo menos {min} {property}.",
	"united-states": "Estados Unidos",
	"field-signature-captured": "Capturado",
	"compare-on-or-before": "{property} debe ser igual o anterior {compareSource}.",
	"order-balance-due-label": "Saldo debido",
	"required-if-less-than": "{property} es necesario cuando {compareSource} es menor que {} compareValue.",
	"credit-card-postalcode": "Código Postal",
	"form-not-available-message": "Este formulario no está disponible actualmente.",
	"element-label-address": "Dirección",
	"receipt-notification-trx-details-number": "Número",
	"public-submission-warning": "Por favor, no envíe contraseñas mediante Cognito Forms.",
	"save-and-resume-no-expiration-email-message": "Use el enlace abajo para finalizar el formulario.",
	"fileupload-excluded-file-type-message": "No se pueden subir archivos de este tipo.",
	"payment-subtotal": "Total parcial",
	"collapse": "Contraer",
	"save-button-text": "Guardar",
	"field-datepicker-prev-year": "Año anterior",
	"signature-type": "escribir",
	"order-amount-minimum": "Cantidad a pagar debe ser al menos 1,00  €.",
	"string-format-numeric": "{property} sólo debe contener números.",
	"entry-confirmation-entry-details-header": "Detalles de la entrada",
	"connected-to-venmo": "Conectado a Venmo.",
	"format-percentage": "#,## %",
	"receipt-notification-header": "Recibo",
	"clear": "Borrar",
	"today": "Hoy",
	"required-name-last": "Apellidos es necesaria.",
	"marketing-button-3": "Inténtalo Ahora",
	"expand": "Expandir",
	"compare-greater-than": "{property} debe ser mayor que {compareSource}.",
	"field-ratingscale-will-wont-label": "Lo haré / No lo haré",
	"required-name-first": "Nombre es necesario.",
	"save-and-resume-one-day-expiration-message": "Copie el enlace abajo o ingrese su correo electrónico para finalizar el formulario dentro del día siguiente.",
	"required-asterisk": "necesario",
	"credit-card-required": "Se requiere tarjeta de crédito.",
	"address-state-province-region": "Estado / provincia / región",
	"save-and-resume-email-sent-message": "Se envió el correo electrónico.",
	"workflow-action": "Acción",
	"field-ratingscale-will-wont-options": "Definitivamente no|Probablemente no|No estoy seguro|Probablemente|Definitivamente",
	"save-and-resume-email-label": "Envíeme un correo electrónico con mi enlace:",
	"field-ratingscale-agree-disagree-options": "Muy en desacuerdo|En desacuerdo|Neutral|De acuerdo|Totalmente de acuerdo",
	"order-exception-order-already-paid": "Este pedido ya se ha pagado.",
	"fileupload-download-text": "Descargar",
	"address-state": "Estado",
	"allowed-values": "{property} no está en la lista de valores permitidos.",
	"shared-entry-workflow-email-button-label": "Abrir el formulario",
	"compare-equal": "{property} debe ser el mismo que {compareSource}.",
	"field-datepicker-clear": "Despejar",
	"name-first": "Nombre",
	"save-and-resume-message": "Se ha guardado su progreso.",
	"save-and-resume-no-expiration-message": "Copie el enlace abajo o ingrese su correo electrónico para finalizar el formulario.",
	"entry-notification-view-details-text": "Ver detalles",
	"order-exception-default-message": "Incapaz de procesar transacciones.",
	"public-report-abuse-link-text": "Reportar abuso",
	"order-amount-paid": "Cantidad pagada",
	"element-label-default": "Intitulado",
	"countries": "Afganistán|Albania|Alemania|Andorra|Angola|Anguilla|Antigua y Barbuda|Antillas Neerlandesas|Arabia Saudí|Argelia|Argentina|Armenia|Aruba|Australia|Austria|Azerbaiyán|Bahamas|Bahrein|Bangladesh|Barbados|Bélgica|Belice|Benin|Bermuda|Bielorrusia|Bolivia|Bosnia-Herzegovina|Botswana|Brasil|Brunei Darussalam|Bulgaria|Burkina Faso|Burundi|Bután|Cabo Verde|Camboya|Camerún|Canadá|Chad|Chile|China|Chipre|Ciudad del Vaticano|Ciudad del Vaticano (Santa Sede)|Colombia|Comoras|Congo, República of(Brazzaville)|Corea, popular democrática \u0027 s REP (Corea del norte)|Corea, República de Corea (del sur)|Costa Rica|Costa de Marfil|Croacia|Cuba|Dinamarca|Djibouti|Dominica|Ecuador|Egipto|El Salvador|Emiratos Árabes Unidos|Eritrea|Eslovaquia (República Eslovaca)|Eslovenia|España|Estados Unidos|Estonia|Etiopía|Federación de Rusia|Fiji|Filipinas|Finlandia|Francia|Gabón|Gambia|Georgia|Ghana|Gibraltar|Gran Bretaña|Granada|Grecia|Groenlandia|Guadalupe|Guam|Guatemala|Guayana francesa|Guinea|Guinea Ecuatorial|Guinea-Bissau|Guyana|Haití|Honduras|Hong Kong|Hungría|India|Indonesia|Irak|Irán (República Islámica del)|Irlanda|Isla de la reunión|Isla de Man|Isla de Navidad|Isla Pitcairn|Islandia|Islas Faroe|Islas Caimán|Islas Cocos (Keeling)|Islas Cook|Islas Malvinas|Islas Marianas del norte|Islas Marshall|Islas Salomón|Islas Turcas y Caicos|Islas Vírgenes (británicas)|Islas Wallis y Futuna|Israel|Italia|Jamaica|Japón|Jordania|Kazajstán|Kenia|Kirguizistán|Kiribati|Kosovo|Kuwait|La Antártida|Lao, personas \u0027 República Democrática|Lesotho|Letonia|Líbano|Liberia|Libia|Liechtenstein|Lituania|Luxemburgo|Macao|Macedonia del Norte, República de|Madagascar|Malasia|Malawi|Maldivas|Malí|Malta|Marruecos|Martinica|Mauricio|Mauritania|Mayotte|México|Micronesia, Estados federales de|Moldova, República de|Mónaco|Mongolia|Montenegro|Montserrat|Mozambique|Myanmar, Birmania|Namibia|Nauru|Nepal|Nicaragua|Níger|Nigeria|Niue|Islas Marianas del Norte|Noruega|Nueva Zelanda|Nueva Caledonia|Omán|Países Bajos|Pakistán|Palau|Panamá|Papua Nueva Guinea|Paraguay|Perú|Polinesia francesa|Polonia|Portugal|Puerto Rico|Qatar|Reino Unido|República Checa|República Dominicana|República Centroafricana|República Democrática del Congo (Kinshasa)|Ruanda|Rumania|Sáhara Occidental|Saint Kitts y Nevis|Saint Vincent y las Granadinas|Samoa|Samoa Americana|San Marino|Santa Lucía|Santo Tomé y Príncipe|Senegal|Serbia|Seychelles|Sierra Leona|Singapur|Siria, República Árabe Siria|Somalia|Sri Lanka|Sudáfrica|Sudán|Sudán del sur|Suecia|Suiza|Surinam|Swazilandia|Tailandia|Taiwán (República de China)|Tanzania; oficialmente la República Unida de Tanzanía|Tayikistán|Territorios franceses del sur|Territorios palestinos|Tíbet|Timor Oriental (Timor-Leste)|Timor-Leste (Timor Oriental)|Togo|Tokelau|Tonga|Trinidad y Tobago|Túnez|Turkmenistán|Turquía|Tuvalu|Ucrania|Uganda|Uruguay|Uzbekistán|Vanuatu|Venezuela|Vietnam|Virgin Islands (U.S.)|Yemen|Zambia|Zimbabue",
	"name-middleinitial": "MI",
	"order-exception-empty-order": "Orden debe contener al menos un elemento de línea.",
	"compare-not-equal": "{property} debe ser diferente de {compareSource}.",
	"entry-notification-footer": "Usted está recibiendo este correo electrónico porque ha seleccionado la opción recibir por correo electrónico notificaciones sobre su forma de Cognito Forms.",
	"save-and-resume-copy-link-label": "Copie el enlace al formulario:",
	"entry-confirmation-footer": "Usted está recibiendo este correo electrónico porque usted completó una transacción con [Name].",
	"required-if-on-or-before": "{property} es necesario cuando {compareSource} es en o antes {compareValue}.",
	"string-format": "{property} debe estar formateado como {formatDescription}.",
	"switch-to-drawing-mode": "Cambiar del modo escritura al modo dibujo.",
	"switch-to-typing-mode": "Cambiar del modo dibujo al modo escritura."
};
